/*
 * Selectable contact links.
 * -----------------------------------------------------------------------------
 * Makes the VALUE inside a tel: / mailto: link selectable and copyable, without
 * giving up the link itself. Loaded site-wide from layout/theme.liquid because
 * these links appear both in the PDP inquiry modal
 * (snippets/product-inquiry-modal.liquid) and in FAQ answer prose, which is a
 * `richtext` setting and therefore cannot carry its own script.
 *
 * The problem this solves, precisely. Two default browser behaviours combine:
 *
 *   1. <a> elements are natively draggable. Pressing down on text inside a link
 *      and moving starts a LINK DRAG (dragging the URL), so a text selection
 *      never begins. The value simply cannot be highlighted.
 *   2. Even once a selection exists, mouseup inside the anchor fires a click,
 *      which follows tel:/mailto:.
 *
 * Nothing in theme.css blocks selection here (verified 2026-09-01: the only
 * user-select:none rules are on the gallery, PhotoSwipe, before-after and
 * marquee). So this is anchor semantics, not a theme bug, and it applies to
 * every tel:/mailto: link on the site.
 *
 * What is deliberately NOT changed: a plain click leaves the selection
 * collapsed, so tap-to-call, mailto and keyboard Enter all behave exactly as
 * before. Only a release that lands on a real selection inside the link is
 * cancelled.
 */
(function () {
  if (window.__lunburgSelectableContacts) return;
  window.__lunburgSelectableContacts = true;

  var SELECTOR = 'a[href^="tel:"], a[href^="mailto:"]';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  /* Turning off the native link drag is what makes the value selectable at all.
     product-inquiry-modal.liquid also sets draggable="false" in its own markup
     so the modal works before this script runs; this pass covers the links we
     cannot edit, such as the FAQ richtext answers. */
  ready(function () {
    document.querySelectorAll(SELECTOR).forEach(function (a) {
      a.setAttribute('draggable', 'false');
    });
  });

  /* Delegated on document so it does not care when the link appeared, nor that
     <x-modal> relocates the inquiry modal to <body> when it opens. */
  document.addEventListener('click', function (e) {
    var link = e.target instanceof Element ? e.target.closest(SELECTOR) : null;
    if (!link) return;

    var sel = window.getSelection();
    if (!sel || sel.isCollapsed || !sel.toString().trim()) return;

    if (link.contains(sel.anchorNode) || link.contains(sel.focusNode)) {
      e.preventDefault();
    }
  });
})();
